import logService from '@/services/log-service'

interface LogEntry {
	timestamp: string
	message: string
	data?: any
}

let currentLogs: LogEntry[] = []

export const getLogFileName = (bookingId?: string | number): string => {
	if (bookingId) return `booking-${bookingId}.log`
	const now = new Date()
	const formatted = now.toISOString().replace(/[:.]/g, '-')
	return `log_${formatted}.log`
}

export const recordLog = (fileName: string, message: string, data?: any): void => {
	const entry = {
		timestamp: new Date().toISOString(),
		message,
		data,
	}
	currentLogs.push(entry)
	try {
		localStorage.setItem(`bookingLogs/${fileName}`, JSON.stringify(currentLogs))
	} catch (err) {
		console.error('Log buffering failed:', err)
	}
}

export const flushLogs = async (fileName: string, bookingId?: string | number): Promise<void> => {
	try {
		const finalName = bookingId ? `booking-${bookingId}.log` : fileName
		const saved = localStorage.getItem(`bookingLogs/${fileName}`)
		const logs = saved ? JSON.parse(saved) : currentLogs

		await logService.uploadBookingLog({
			fileName: finalName,
			logs,
		})

		localStorage.removeItem(`bookingLogs/${fileName}`)
		currentLogs = []
	} catch (err) {
		console.error('Flush logs failed:', err)
	}
}
